// Impetus is included in a global js file
// since it was erroring out our build process.....

import Impetus from 'impetus'

// small helper to do something on momentum
// input (normalizes mousewheel and touchmove)
export default function onMomentum (opts = {}) {

  opts = Object.assign({
    callback: null,
    touchSource: window,
    scrollSource: window
  }, opts)

  let delta = 1
  let lastTouchY = 0
  let eventEndTimer = null
  let impetusInstance = null

  function handleWheel (event) {
    delta = -1 * getWheelDelta(event)
    if (typeof opts.callback === 'function') opts.callback(delta)
    clearTimeout(eventEndTimer)
    eventEndTimer = setTimeout(resetDelta, 50)
  }

  function handleImpetus (x, y) {
    delta = (lastTouchY - y) * 8
    if (typeof opts.callback === 'function') opts.callback(delta)
    lastTouchY = y
    clearTimeout(eventEndTimer)
    eventEndTimer = setTimeout(resetDelta, 50)
  }

  function start () {
    opts.scrollSource.addEventListener('wheel', handleWheel)
    impetusInstance = new Impetus({
      source: opts.touchSource,
      update: handleImpetus
    })
    return this
  }

  function stop () {
    opts.scrollSource.removeEventListener('wheel', handleWheel)
    if (impetusInstance) impetusInstance.destroy()
    return this
  }

  function resetDelta () {
    delta = delta < 0 ? -1 : 1
    if (typeof opts.callback === 'function') opts.callback(delta)
  }

  function getWheelDelta (event) {
    return event.wheelDelta 
        || -(event.deltaY * 2) 
        || -event.detail 
        || event.originalEvent.wheelDelta 
        || -event.originalEvent.detail 
        || -(event.originalEvent.deltaY * 25) 
        || null
  }

  return {
    start: start,
    stop: stop
  }
}